<template>
  <div class="otp-container">
    <div class="otp-otp-container">
      <span class="otp-title">
        Masukan kode OTP yang dikirim ke email anda adind****@gmail.com
      </span>
      <div class="otp-row-box">
        <div class="otp-container1">
          <input type="text" class="otp-input-otp input" />
        </div>
        <div class="otp-container2">
          <input type="text" class="otp-input-otp1 input" />
        </div>
        <div class="otp-container3">
          <input type="text" class="otp-input-otp2 input" />
        </div>
        <div class="otp-container4">
          <input type="text" class="otp-input-otp3 input" />
        </div>
      </div>
      <div class="otp-btn-login"><span class="otp-text">Submit</span></div>
      <div class="otp-container5">
        <span class="otp-text1">Belum menerima kode OTP?</span>
        <span class="otp-text2">Kirim lagi</span>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from "../components/footer";

export default {
  name: 'Otp',
  props: {},
  components: {
    Footer
  },
}
</script>

<style scoped>
.otp-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #EAE3D9;
}
.otp-otp-container {
  flex: 0 0 auto;
  width: 400px;
  height: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 180px;
  padding-bottom: 140px;
}
.otp-title {
  text-align: center;
  font-family: Montserrat;
  line-height: 2;
  margin-bottom: var(--dl-space-space-oneandhalfunits);
}
.otp-row-box {
  width: 100%;
  display: flex;
  column-gap: 10px;
  align-items: flex-start;
  flex-direction: row;
}
.otp-container1 {
  flex: 25%;
  width: 200px;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
}
.otp-input-otp {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 2em;
  flex-basis: 25%;
  font-family: Lora;
}
.otp-container2 {
  flex: 25%;
  width: 200px;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
}
.otp-input-otp1 {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 2em;
  flex-basis: 25%;
  font-family: Lora;
}
.otp-container3 {
  flex: 25%;
  width: 200px;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
}
.otp-input-otp2 {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 2em;
  flex-basis: 25%;
  font-family: Lora;
}
.otp-container4 {
  flex: 25%;
  width: 200px;
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
}
.otp-input-otp3 {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: 2em;
  flex-basis: 25%;
  font-family: Lora;
}
.otp-btn-login {
  flex: 0 0 auto;
  width: 100%;
  cursor: pointer;
  height: 64px;
  display: flex;
  position: relative;
  margin-top: var(--dl-space-space-unit);
  align-items: center;
  justify-content: flex-start;
  background-color: #1F252C;
}
.otp-text {
  color: #fff;
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.24em;
  text-transform: capitalize;
  text-align: center;
}
.otp-container5 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  margin-top: var(--dl-space-space-unit);
  align-items: flex-start;
  justify-content: center;
}
.otp-text1 {
  font-family: Montserrat;
}
.otp-text2 {
  color: #6B89E8;
  font-family: Montserrat;
  margin-left: var(--dl-space-space-halfunit);
}
@media(max-width: 991px) {
  .otp-otp-container {
    width: 100%;
    padding-top: 200px;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
